'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
document.addEventListener('DOMContentLoaded', function () {
    /**
     * Vertical Features
     *
     * 1. Es kann immer nur ein Panel geöffnet sein.
     * 2. Wenn ein Panel geöffnet ist, wird das Bild des Panels angezeigt.
     * 3. Wenn ein Panel geschlossen ist, wird das Bild des Panels ausgeblendet.
     *
     */
    /**
     * Instance lays on every Navigation Button
     */
    var AccordionSwitcher = /** @class */ (function () {
        function AccordionSwitcher(domNode) {
            this.isOpen = false;
            this.btnEl = domNode;
            var controlsId = this.btnEl.getAttribute('aria-controls');
            this.accordionWrapperEl = document.getElementById(controlsId);
            this.btnEl.addEventListener('click', this.onButtonClick.bind(this));
        }
        AccordionSwitcher.prototype.onButtonClick = function () {
            if (this.isOpen) {
                return; // Do nothing if already open
            }
            this.toggle(!this.isOpen);
        };
        AccordionSwitcher.prototype.toggle = function (newState) {
            this.isOpen = newState;
            console.log('Accordion Switcher state:', this.isOpen);
            // handle DOM updates
            if (this.isOpen) {
                this.show();
            }
            else {
                this.hide();
            }
        };
        AccordionSwitcher.prototype.show = function () {
            // if (this.isOpen) {
            //     console.warn('Accordion is already open!');  
            //     return; 
            // } 
            hideAllAccordions(this);
            this.btnEl.setAttribute('aria-expanded', 'true');
            this.accordionWrapperEl.hidden = false;
            this.btnEl.classList.add('vf-button-navigation__button--active');
            this.accordionWrapperEl.classList.add('vf-accordion-wrapper--open');
            this.openFirstPanel();
        };
        AccordionSwitcher.prototype.hide = function () {
            this.btnEl.setAttribute('aria-expanded', 'false');
            this.accordionWrapperEl.hidden = true;
            this.btnEl.classList.remove('vf-button-navigation__button--active');
            this.accordionWrapperEl.classList.remove('vf-accordion-wrapper--open');
        };
        AccordionSwitcher.prototype.openFirstPanel = function () {
            var firstPanel = this.accordionWrapperEl.querySelector('.vf-accordion__trigger');
            if (firstPanel) {
                firstPanel.click(); // Simulate a click to open the first panel
            }
        };
        return AccordionSwitcher;
    }());
    var Accordion = /** @class */ (function () {
        function Accordion(domNode, progressbarController) {
            this.maxHeight = '0';
            this.progressbarController = progressbarController;
            this.rootEl = domNode;
            this.buttonEl = this.rootEl.querySelector('button[aria-expanded]');
            var controlsId = this.buttonEl.getAttribute('aria-controls');
            this.imageEl = document.querySelector(".vf-accordion__image[data-accordion-controls=\"".concat(controlsId, "\"]"));
            this.contentEl = document.getElementById(controlsId);
            this.isOpen = this.buttonEl.getAttribute('aria-expanded') === 'true';
            // add event listeners
            this.buttonEl.addEventListener('click', this.onButtonClick.bind(this));
            this.getMaxHeight(); // Set the max height of the content element based on its natural height
            // check if all Elements are found 
            if (!this.rootEl || !this.buttonEl || !this.contentEl || !this.imageEl) {
                console.warn('Accordion element(s) not found!');
                return;
            }
            return this;
        }
        Accordion.prototype.onButtonClick = function () {
            this.toggle(!this.isOpen);
        };
        Accordion.prototype.toggle = function (open) {
            var _this = this;
            // handle DOM updates
            this.buttonEl.setAttribute('aria-expanded', "".concat(open));
            if (open) {
                if (this.isOpen) {
                    return; // Do nothing if already open
                }
                closeAllPanels(); // Close all other panels 
                this.rootEl.classList.add('vf-accordion--open');
                this.contentEl.classList.add('vf-accordion__panel--open');
                this.contentEl.setAttribute('aria-hidden', 'false');
                this.contentEl.setAttribute('aria-expanded', 'true');
                this.contentEl.style.maxHeight = this.maxHeight;
                this.imageEl.classList.add('open');
                this.imageEl.setAttribute('aria-hidden', 'false');
                setTimeout(function () {
                    _this.progressbarController.updateFromElement(_this.rootEl);
                }, 350);
            }
            else {
                this.rootEl.classList.remove('vf-accordion--open');
                this.contentEl.classList.remove('vf-accordion__panel--open');
                this.contentEl.setAttribute('aria-hidden', 'true');
                this.contentEl.setAttribute('aria-expanded', 'false');
                this.contentEl.style.maxHeight = '0px'; // Reset max height to 0 when closed
                this.imageEl.classList.remove('open');
                this.imageEl.setAttribute('aria-hidden', 'true');
                this.progressbarController.updateHeight(0);
            }
        };
        Accordion.prototype.getMaxHeight = function () {
            this.maxHeight = this.getNaturalHeightSafe(this.contentEl) + 'px';
            this.contentEl.dataset.maxHeight = this.maxHeight; // Store the max height in a data attribute for reference 
        };
        Accordion.prototype.getNaturalHeightSafe = function (el) {
            var clone = el.cloneNode(true);
            clone.style.visibility = 'hidden';
            clone.style.position = 'absolute';
            clone.style.display = 'block';
            clone.style.maxHeight = 'none';
            clone.style.height = 'auto';
            clone.style.overflow = 'visible';
            clone.style.pointerEvents = 'none';
            clone.style.zIndex = '-1';
            clone.style.opacity = '0';
            document.body.appendChild(clone);
            var height = clone.scrollHeight;
            document.body.removeChild(clone);
            return height;
        };
        // Add public open and close methods for convenience
        Accordion.prototype.open = function () {
            this.toggle(true);
        };
        Accordion.prototype.close = function () {
            this.toggle(false);
        };
        return Accordion;
    }());
    var ProgressbarController = /** @class */ (function () {
        function ProgressbarController() {
            this.barInner = document.querySelector('.vertical-bar__inner');
        }
        /** Setzt Höhe der Progressbar basierend auf dem aktiven Panel */
        ProgressbarController.prototype.updateHeight = function (height) {
            this.barInner.style.maxHeight = height + 'px';
        };
        /** Setzt die vertikale Position der Progressbar */
        ProgressbarController.prototype.updateOffset = function (relativeTop) {
            this.barInner.style.top = relativeTop + 'px';
        };
        /**
         *
         * @param accEl - Accordion element
         */
        ProgressbarController.prototype.updateFromElement = function (accEl) {
            console.log('Acc Element', accEl);
            var height = accEl.scrollHeight;
            var panelEl = accEl.querySelector('.vf-accordion__panel');
            var maxHeight = parseInt(panelEl.dataset.maxHeight, 10); // Parse maxHeight as a number
            var completeHeight = height; // + maxHeight;
            var parentWrap = accEl.closest('.vf-accordion-wrapper');
            var offset = accEl.getBoundingClientRect().top - parentWrap.getBoundingClientRect().top;
            console.log('Update Height to ', completeHeight);
            console.log('Update Offset to ', offset);
            this.updateHeight(completeHeight);
            this.updateOffset(offset);
        };
        return ProgressbarController;
    }());
    // init accordions
    var accordions = document.querySelectorAll('.vf-accordion');
    var navButtons = document.querySelectorAll('.vf-button-navigation__button');
    var progressbarController = new ProgressbarController();
    var panelInstances = [];
    var accordionInstances = [];
    function hideAllAccordions(openAccordion) {
        accordionInstances.forEach(function (instance) {
            if (instance !== openAccordion) {
                instance.toggle(false); // Close all other accordions
            }
        });
    }
    function closeAllPanels() {
        panelInstances.forEach(function (instance) {
            instance.close();
        });
    }
    navButtons.forEach(function (buttonEl) {
        var instance = new AccordionSwitcher(buttonEl);
        accordionInstances.push(instance);
    });
    accordions.forEach(function (accordionEl) {
        var instance = new Accordion(accordionEl, progressbarController);
        panelInstances.push(instance);
    });
    // Open first Accordion on page load 
    if (accordionInstances.length > 0) {
        accordionInstances[0].show(); // Open the first accordion by default
    }
});
